import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISubmit, SubmitResponse } from '@interfaces';
import {
  MultiSignerGetResponseHydrated_Gift,
  MultiSignerGetResponseHydrated_IT,
  MultiSignerPostPayload,
  MXMPatchResponse,
} from '@interfaces/models/multi-signer-approval';
import { RecaptchaMockResult } from '@interfaces/submit/submit.service.interface';
import { Observable } from 'rxjs';

import { FMFResponse } from '../fraud-micro-frontend/fmf.service';

@Injectable({
  providedIn: 'root',
})
export class MultiSignerApprovalService {
  readonly endpoint = 'secure/multi-signer';
  constructor(private http: HttpClient) {}

  getTransfer(
    transferId: string,
    poid: string,
  ): Observable<MultiSignerGetResponseHydrated_IT | MultiSignerGetResponseHydrated_Gift> {
    const headers = new HttpHeaders().set('poid', poid);
    return this.http.get<MultiSignerGetResponseHydrated_IT | MultiSignerGetResponseHydrated_Gift>(
      `${this.endpoint}?transferId=${transferId}`,
      {
        headers,
      },
    );
  }

  sendTransfer(
    mxmRequestData: MultiSignerPostPayload,
    poid: string,
  ): Observable<{ message: string }> {
    const headers = new HttpHeaders().set('poid', poid);
    return this.http.post<{ message: string }>(this.endpoint, mxmRequestData, { headers });
  }

  addOwnerConsentForMXM(transferId: string, filenetPayload: ISubmit): Observable<MXMPatchResponse> {
    return this.http.post<MXMPatchResponse>(`${this.endpoint}/consent`, {
      transferId,
      filenet: filenetPayload,
    });
  }

  finalizeTransfer(
    mockRecaptchaLevel: RecaptchaMockResult,
    fmfResponse: FMFResponse,
    submitData: ISubmit,
    transferId: string,
  ): Observable<SubmitResponse> {
    return this.http.post<SubmitResponse>(`${this.endpoint}/submit`, {
      ...submitData,
      fmfResponse,
      mockRecaptchaLevel,
      transferId,
    });
  }
}
